import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('users');
const type = createActionType('users');

export const LIST_USER_DETAILS = apiType('ListUserDetails');
export const GET_ACCEPT_TERMS = apiType('GetAcceptTerms');
export const ACCEPT_TERMS = apiType('AcceptTerms');
export const INITIATE_KEYCLOAK = type('InitiateKeycloak');
export const SIGN_IN_KEYCLOAK = apiType('SignInKeycloak');
export const KEYCLOAK_TOKEN_REFRESH = apiType('KeycloakTokenRefresh');
export const KEYCLOAK_CONNECTION_ERROR = type('KeycloakConnectionError');
export const KEYCLOAK_TOKEN_REFRESHED = type('KeycloakTokenRefreshed');
export const SIGN_OUT = type('SignOut');
